import { Engine, Slip } from '../src/slip-lib'

let engine = new Engine(document.querySelector("#rootSlip"));
let rootSlip = engine.getRootSlip();
// let rootSlip = new Slip("rootSlip", [], engine, {});
engine.setRootSlip(rootSlip);
//rootSlip.setEngine(engine);
//let intro = new Slip("", "Slip Intro", [], engine, {});
// We want a fine control, so we don't let the presentation order the slips by their order of appearance in the HTML file.
// (this is mostly because we want the slips "red" and "blue" in the middle of the slip "future")

// Creation of slips

// rootSlip.setAction([
//     intro,
//     base,
//     beamerPart,
//     future,
//     // scaleTest,
//     // blue,
//     //    future, // coming back to the unfinished "future"
//     //    links,
//     // (slip) => {
    
//     // }
// ]);
// presentation.setSlips([
//     intro,
//     base,
//     beamerPart,
//     future,
//     // scaleTest,
//     blue,
//     future, // coming back to the unfinished "future"
//     links,
// ]);
// let controller = new Controller(engine);
